export const containerStyle = {
  marginTop: 40,
};

export const titleContainerStyle = {
  marginBottom: 16,
};

export const titleStyle = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 4,
};

export const tableStyles = `
  .row-avaliando {
    background-color: #e6f7ff !important;
  }
  .row-avaliando:hover {
    background-color: #bae7ff !important;
  }
  .row-com-problema {
    background-color: #fff1f0 !important;
    border-left: 3px solid #ff4d4f !important;
  }
  .row-com-problema:hover {
    background-color: #ffccc7 !important;
  }
`;

export const cellReadonlyStyle = {
  textAlign: 'center' as const,
  color: '#666',
  fontWeight: 500,
  backgroundColor: '#fafafa',
  padding: '4px 8px',
  borderRadius: 4,
};

export const cellCenterStyle = {
  textAlign: 'center' as const,
  fontWeight: 500,
  color: '#666',
};

export const cellHighlightStyle = {
  textAlign: 'center' as const,
  fontWeight: 600,
  color: '#ff4d4f',
  fontSize: 14,
};
